import { TranslationWidth } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { NgbDate, NgbDatepicker, NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';


@Component({
	selector: 'datepicker',
	templateUrl: './datepicker.component.html',
	providers: [{ provide: NgbDatepickerI18n, useClass: DatepickerComponent }],
	styleUrls: ['./datepicker.component.scss']
})
export class DatepickerComponent implements NgbDatepickerI18n, AfterViewInit, OnInit {

	private readonly WEEK_DAYS: string[] = [ 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom' ];
	private readonly MONTH_SHORT: string[] = [ 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic' ];
	private readonly MONTH_LONG: string[] = [ 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre' ];

	@ViewChild( "dp", { static: true } )
	datepicker: NgbDatepicker;

	@Input()
	minDate: NgbDateStruct;
	@Input()
	maxDate: NgbDateStruct;
	@Input()
	startDate: NgbDateStruct;
	@Input()
	navigation: string;
	@Input()
	today: NgbDateStruct;

	private configStartDate: NgbDateStruct;

	// Sobran
	// getWeekdayShortName

	constructor() {
	}

	ngOnInit(): void {
		this.configStartDate = this.startDate;
	}

	ngAfterViewInit(): void {
		setTimeout( () => {
			this.datepicker.focusSelect();
		}, 0 );
	}

	getWeekdayLabel( weekday: number, width?: TranslationWidth ): string {
		return this.WEEK_DAYS[ weekday - 1 ];
	}

	getWeekLabel(): string {
		return null;
	}

	getMonthShortName( month: number, year?: number ): string {
		return this.MONTH_SHORT[ month - 1 ];
	}

	getMonthFullName( month: number, year?: number ): string {
		return this.MONTH_LONG[ month - 1 ];
	}

	getMonthLabel( date: NgbDateStruct ): string {
		return this.getMonthShortName( date.month, date.year );
	}

	getDayAriaLabel( date: NgbDateStruct ): string {
		return `${date.day}-${date.month}-${date.year}`;
	}

	getDayNumerals( date: NgbDateStruct ): string {
		return date.day.toString();
	}

	getWeekNumerals( weekNumber: number ): string {
		return weekNumber.toString();
	}

	getYearNumerals( year: number ): string {
		return year.toString();
	}

	public onDateSelect(): Observable<NgbDate> {
		return this.datepicker.dateSelect;
	}

	public onStartDateSelected() {
		this.datepicker.onDateSelect( NgbDate.from( this.today ) );
	}

}
